/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { getAsset } from '@msdyn365-commerce/core';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IDlvryProductSheetViewProps } from './dlvry-product-sheet';

export default (props: IDlvryProductSheetViewProps) => {
    const { resources, ProductSheet, className, onDownloadProductSheet } = props;

    const getAssetFixed = (assetPath: string) => {
        let assetUrl = getAsset(assetPath, props.context.request);

        if (typeof window === "undefined") {
            return assetUrl;
        }

        const SUBMISSIONID = (window as any | undefined)?.___initialData___?._environmentVariable?.['SUBMISSIONID'];

        if (assetUrl.includes('00000-00000-00000-00000-00000') && SUBMISSIONID) {
            assetUrl = assetUrl.replace('00000-00000-00000-00000-00000', SUBMISSIONID);
        }

        return assetUrl;
    };

    return (
        <Module {...ProductSheet}>
            <button className={`${className}__download-button`} onClick={onDownloadProductSheet}>
                <img src={getAssetFixed('icons/file-pdf.svg')} width={22.39} height={22.39} />
                <span>{resources.productSheetButtonText}</span>
            </button>
        </Module>
    );
};
